import { VerificationType } from "projects/shared/src/public-api";

export class User {
    userId: string;
    verificationType: VerificationType

    constructor(userId?: string, verificationType?: VerificationType) {
        this.userId = userId;
        this.verificationType = verificationType;
    }
}
export class LoginModel {
    userMailOrPhone: string;
    password: string;
    captchaToken: string;
    verificationCode: string;
    verificationType: VerificationType;

    constructor(userMailOrPhone?: string, password?: string, captchaToken?: string, verificationCode?: string, verificationType?: VerificationType) {
        this.userMailOrPhone = userMailOrPhone;
        this.password = password;
        this.captchaToken = captchaToken;
        this.verificationCode = verificationCode;
        this.verificationType = verificationType;
    }

}

export class verificationCodeModel {
    verificationCodeSend: boolean;
    encryptedNumMailOrPhone: string;
    verificationType: VerificationType;
}